import React from 'react';
import { useLanguage } from '../../lib/LanguageContext';

const WHATSAPP_NUMBER = '31643875097';
const WhatsAppIcon = ({ className = 'w-6 h-6' }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.11 17.66c-.27-.13-1.59-.78-1.83-.87-.25-.09-.42-.13-.6.13-.18.27-.69.87-.85 1.05-.16.18-.31.2-.58.07-.27-.13-1.14-.42-2.17-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.6-1.45-.83-1.99-.22-.52-.44-.45-.6-.46h-.51c-.18 0-.47.07-.71.34-.24.27-.93.91-.93 2.22 0 1.3.95 2.56 1.08 2.74.13.18 1.87 2.85 4.52 3.99.63.27 1.12.43 1.5.55.63.2 1.21.17 1.66.1.51-.08 1.59-.65 1.81-1.27.22-.62.22-1.16.16-1.27-.07-.11-.25-.18-.52-.31z" />
    <path d="M27.18 4.82A15.94 15.94 0 0 0 16 .2C7.27.2.2 7.27.2 16c0 2.78.73 5.49 2.11 7.88L.06 31.8l8.13-2.13A15.94 15.94 0 0 0 16 31.8c8.73 0 15.8-7.07 15.8-15.8 0-4.22-1.64-8.19-4.62-11.18zM16 29.13a13.1 13.1 0 0 1-6.68-1.83l-.48-.28-4.83 1.27 1.29-4.71-.31-.49A13.13 13.13 0 1 1 29.13 16c0 7.24-5.89 13.13-13.13 13.13z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  const href = `https://wa.me/${WHATSAPP_NUMBER}`;
  return (
    <a
      href={href}
      data-testid="whatsapp-floating-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp}
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 group flex items-center gap-3"
    >
      <span className="hidden md:inline-flex items-center bg-cream text-ink-900 border border-sand-200 text-sm px-4 py-2 rounded-full shadow-[0_8px_24px_rgba(45,51,47,0.10)] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        {t.whatsapp}
      </span>
      <span className="relative flex items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-soft-pulse" />
        <span className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_12px_30px_rgba(37,211,102,0.45)] hover:scale-[1.04] transition-transform">
          <WhatsAppIcon className="w-7 h-7" />
        </span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
